module.exports = __webpack_public_path__ + "static/membership-current-fcb06304ce5f60122e478c456c9639eb.jpg";